
window.TABLE_HEADER_TRACK_IDS = {
    TOP_HEADER_ROW: 'TOP_HEADER_ROW',
    LEFT_HEADER_COL: 'LEFT_HEADER_COL'
};